<template>
  <Dialog
      :title="title"
      :show="showDialog"
      @onCancel="onCancel"
      @onConfirm="onConfirm"
      class="jy-common-message-box"
      :width="width"
  >
    <div class="query-box">
      <el-form :inline="true" :model="modelData" ref="selectCustomersForm">
        <el-form-item
            :prop="value.conditonKey"
            :label="value.conditonKeyShow"
            v-for="(value, key) in data"
            :key="key"
        >
          <el-select
              v-if="value.textBoxType == 'select'"
              v-model="modelData[value.conditonKey]"
              clearable
          >
            <el-option label="是" value="是" />
            <el-option label="否" value="否" />
          </el-select>
          <el-date-picker
              v-else-if="value.textBoxType == 'datetime'"
              v-model="modelData[value.conditonKey]"
              value-format="YYYY-MM-DD HH:mm:ss"
              type="datetime"
          />
          <el-date-picker
              v-else-if="value.textBoxType == 'date'"
              v-model="modelData[value.conditonKey]"
              value-format="yyyy-MM-dd"
              type="date"
          />
          <el-input v-else v-model="modelData[value.conditonKey]"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-box">
      <el-table
          ref="table"
          class="jy-common-table"
          header-align="center"
          highlight-current-row
          border
          stripe
          :height="450"
          :data="tableData"
          @current-change="handleSelectionChange"
      >
        <el-table-column type="index" label="序号" width="55" align="center" fixed="left"></el-table-column>
        <el-table-column align="center" label="所属分部" prop="deptName" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="客户编号" prop="memberId" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="客户名称" prop="userMemberName" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="客户归属" prop="customerAttribution" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="邮箱" prop="email" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="电话" prop="phone" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="业务员" prop="businessEmployeeName" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="备注" prop="remarks" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="pagination-box" v-if="tableData.length > 0">
      <el-pagination
          :current-page.sync="pagination.page"
          :page-size.sync="pagination.size"
          class="system-page"
          :pager-count="5"
          background
          :total="pagination.total"
          :page-sizes="[10, 20, 50, 100]"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </Dialog>
</template>

<script>
import Dialog from "@/components/dialog/index.vue";
import { Api } from "@/assets/js/api";
import utils from "@/assets/js/tool";
import { Message } from "element-ui";

export default {
  name: "selectCustomers",
  components: {
    Dialog
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: "选择客户"
    },
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "1180"
    }
  },
  data() {
    return {
      showDialog: this.show,
      modelData: {},
      tableData: [],
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      queryArr: [],
      currentRow: null
    };
  },
  watch: {
    show: {
      handler(newVal) {
        this.showDialog = newVal;
      },
      immediate: true
    }
  },
  methods: {
    async onRunPageReport(arr) {
      try {
        const res = await Api.runPageReport({
          conditionReqs: arr,
          number: "member_down_list",
          pageStart: this.pagination.page,
          pageTotal: this.pagination.size
        });

        if (res.status === 200) {
          const data = res.data;
          if (data.status === "success") {
            const datas = data.result.datas;
            this.pagination.total = datas.pageCount;
            const tableArr = datas.data;

            if (utils.jyCheckObjectType(tableArr) === "Array") {
              this.tableData = tableArr.length > 0 ? tableArr : [];
            } else {
              this.tableData = [];
            }
          }
        }
      } catch (error) {
        console.error("API 请求失败", error);
      }
    },
    onSubmit() {
      if (!this.$refs.selectCustomersForm) return;

      this.$refs.selectCustomersForm.validate(valid => {
        if (valid) {
          const arr = Object.keys(this.modelData);
          if (utils.jyCheckObjectType(arr) === "Array") {
            let qArr = [];
            for (let i in this.modelData) {
              qArr.push({
                conditonKey: i,
                conditonVal: this.modelData[i]
              });
            }
            this.queryArr = qArr;
            this.onRunPageReport(qArr);
          }
        }
      });
    },
    handleSizeChange(val) {
      this.pagination.page = 1;
      this.pagination.size = val;
      this.onRunPageReport(this.queryArr);
    },
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.onRunPageReport(this.queryArr);
    },
    handleSelectionChange(val) {
      this.currentRow = val;
    },
    onCancel() {
      this.showDialog = false;
      this.$emit("onCancelSelectCustomers");
    },
    onConfirm() {
      if (this.currentRow) {
        this.$emit("onConfirmSelectCustomers", this.currentRow);
      } else {
        Message({
          message: "请选择1条表格的数据",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-box {
  margin-top: 16px;
}
</style>
